module.exports = __webpack_public_path__ + "img/release-image.da7bde6.png";